import { InjectProperty } from '@jack-henry/frontend-utils/di';
import { Feature, FeatureFlagService } from '@treasury/domain/services/feature-flags';
import { css, html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { fdicLogo } from '../assets/icons';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-fdic-digital-sign';
@customElement(tagName)
export class TmFdicDigitalSign extends TmBaseComponent {
    @property({ type: Boolean })
    public notification = false;

    @property({ type: Boolean })
    public reversed = false;

    @property({ type: String })
    public container = '';

    @InjectProperty({
        async: true,
        token: FeatureFlagService,
    })
    declare private featureFlagService: Promise<FeatureFlagService>;

    @state()
    private disableSign = false;

    protected async firstUpdated() {
        this.disableSign = await (await this.featureFlagService).isEnabled(Feature.FdicDigitalSign);
    }

    protected render() {
        return this.disableSign
            ? nothing
            : html`<div class=${this.container}>
                  ${this.notification ? this.renderNotification() : this.renderDigitalSign()}
              </div>`;
    }

    private renderDigitalSign() {
        return html` <div
            class=${classMap({
                'flex items-center': true,
                'text-white': this.reversed,
            })}
        >
            <tm-icon .icon="${fdicLogo}" color="var(--logo-color)"></tm-icon>
            <div class="pl-2 font-source text-[12.8px] italic leading-snug">
                FDIC-Insured – Backed by the full faith and credit of the U.S. Government
            </div>
        </div>`;
    }

    private renderNotification() {
        return html`<div class="font-source font-normal text-[10px] text-secondary text-wrap">
            Not insured by the FDIC; are not deposits; and may lose value.
        </div>`;
    }

    public static get styles() {
        return css`
            :host,
            :host([theme='dark']) .navigation {
                --logo-color: #003256;
            }
            :host([theme='dark']),
            :host([reversed]) {
                --logo-color: var(--jh-color-gray-0);
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmFdicDigitalSign;
    }
}
